import axios from "axios"
export default (fetch) => {
  return {
    // 安全测试报告信息
    async getSafetyReport() {
      const {data} = await fetch.get('/arcopen/user/config/safety-report')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-应用名称校验
    async verifyAppName(params) {
      const {data} = await fetch.get('/arcopen/user/company-core/verify-appname', {
        params
      })
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // 回调地址校验
    async verifyCbUrl(params) {
      const {data} = await fetch.get('/arcopen/user/webhooks/verify-callback-url', {
        params
      })
      return data
    },
    // 回调地址增删改查
    async upsetCbUrl(body) {
      const form = new FormData()
      const { callback_url, client_id } = body
      form.append('callback_url', callback_url)
      form.append('client_id', client_id)
      const {data} = await fetch.post('/arcopen/user/webhooks/upsert-callback-url', form)
      return data
    },
    // user-应用-提交申请
    async submit(body) {
      const {data} = await fetch.post('/arcopen/user/company-core/submit', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-应用-图标上传
    async iconUpload(file) {
      const form = new FormData()
      form.append('file', file)
      const {data} = await fetch.post('/arcopen/user/company-core/icon/upload', form)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('应用图标上传失败')
      }
    },
    // user-应用-编辑
    async edit(body) {
      const {data} = await fetch.post('/arcopen/user/company-core/edit', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-应用-删除
    async delete(body) {
      const {data} = await fetch.post('/arcopen/user/company-core/delete', body)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-应用-查询
    async view(client_id) {
      const {data} = await fetch.get('/arcopen/user/company-core/view', {
        params: {
          client_id
        }
      })
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('应用查询失败')
      }
    },
    // user-应用查询-列表
    async viewlist(page) {
      const pn = page.pn
      const ps = page.ps
      const app_plat = page.app_plat
      const {data} = await fetch.get('/arcopen/user/company-core/viewlist', {
        params: {
          pn, ps, app_plat
        }
      })
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('应用查询列表失败')
      }
    },
    async configAppType() {
      const {data} = await fetch.get('/arcopen/user/config/apptype')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('app类型获取失败')
      }
    },
  }
}

// 查看企业应用申请是否可以提交
const whether = async (data) => {
  const {data: res} = await axios.post('/arcopen/user/company-core/lock', data)
  if (res.code === 0) {
    return res.data
  } else {
    throw new Error(res.message)
  }
}
// 查看企业应用权限申请是否可以提交
const powerWhether = async (data) => {
  const {data: res} = await axios.post('/arcopen/user/company-scope/lock', data)
  if (res.code === 0) {
    return res.data
  } else {
    throw new Error(res.message)
  }
}
export { whether, powerWhether }